import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
export const WEB_SOURCE_ICON = $icon('world');
export const MEMORY_SEARCH_ICON = $icon('clock-search');
export const KNOWLEDGE_SOURCE_ICON = $icon('book');
export const WIKI_SOURCE_ICON = $icon('book');
export const FILE_SOURCE_ICON = $icon('file');
//# sourceMappingURL=sourceIcons.js.map